module.exports = __webpack_public_path__ + "img/desk2.99edc79e.png";